import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { get } from 'lodash'
import GatherInputForm from './GatherInputForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    loop: '1',
    voice: 'man',
    timeout: '30',
    ...otherProps.initialValues,
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(GatherInputForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Porta/PortaGatherInput/GatherInputForm.container.js